import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ClientModel } from '../../../shared/models/client.model';
import { Title } from '@angular/platform-browser';
import { OauthService } from '../../../shared/services/oauth.service';
import { CommonHttpService } from '../../../shared/services/http.service';
import { TranslateService } from '@ngx-translate/core';
import { Response } from '@angular/http';
import { SubscriptionModel } from '../../../shared/models/subscription.model';
import { NavigationEnd, Router } from '@angular/router';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs/Subscription';

@AutoUnsubscribe()
@Component({
    selector: 'account-subscriptions-list',
    templateUrl: './account.subscriptions.list.component.html',
    styleUrls: ['./../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountSubscriptionsListComponent implements OnDestroy {
    public client: ClientModel;
    public subscriptions: Array<SubscriptionModel> = [];
    public loading = false;
    public error = false;
    public hasMoreToLoad = true;
    private limit = 5;
    private currentOffset = 0;

    oauthLoadedAuthenticatedUser: Subscription;

    constructor(
        protected translate: TranslateService,
        protected titleService: Title,
        protected http: CommonHttpService,
        protected router: Router,
        protected oauth: OauthService
    ) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.oauth.init();
            }
        });

        this.translate.get('ACCOUNT.SUBSCRIPTIONS.TITLE').subscribe((title: string) => {
            this.titleService.setTitle(title);
        });
        this.oauthLoadedAuthenticatedUser = this.oauth.loadedAuthenticatedUser$.subscribe((client: ClientModel) => {
            this.client = client;
            this.indexSubscriptions();
        });
        this.oauth.failedAuthenticatedUser$.subscribe((error: Response) => {
            this.redirectOnFailAuthentication(error.status);
        });
        this.oauth.failedPersistedUser$.subscribe((error: Response) => {
            this.redirectOnFailAuthentication(error.status);
        });
        this.oauth.tokenRefused$.subscribe(() => {
            this.redirectOnFailAuthentication();
        });
    }

    ngOnDestroy() {
        // It's going to be overrided by AutoUnsubscribe
    }

    public loadMore() {
        this.currentOffset += 5;
        this.indexSubscriptions(this.currentOffset);
    }

    private indexSubscriptions(offset: number = 0) {
        this.loading = true;
        this.http
            .useAuth()
            .get(
                `account/clients/${this.client.id}/subscriptions`
                + `?_sort=-id`
                + `&_offset=${+offset}`
                + `&_limit=${+this.limit}`
                + `&_fields=id,start_at,status,plan->description`
                + `&_config=meta-has-more-pages`
                + `&_with=plan`
            )
            .subscribe(
                (response: Response) => {
                    const subscriptions = response.json().data;
                    const meta = response.json().meta;

                    if (offset === 0) {
                        this.subscriptions = [];
                    }

                    for (let index in subscriptions) {
                        if (subscriptions.hasOwnProperty(index)) {
                            this.subscriptions.push(subscriptions[index]);
                        }
                    }

                    this.hasMoreToLoad = meta['meta-has-more-pages'];
                    this.loading = false;
                },
                (error: Error) => {
                    this.error = true;
                    this.loading = false;
                }
            );
    }

    /**
     * Redirect user to index page.
     **/
    private redirectOnFailAuthentication(statusCode = 401) {
        if (statusCode === 401) {
            window.location.href = '/';
        }
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/account/subscriptions/list/account.subscriptions.list.component.ts